/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import TablesWidgetDatasets from "../../../../_start/partials/widgets/tables/TablesWidgetDatasets";

export const DatasetDashboardPage: React.FC = () => {
  return (
    <>
      {/* begin::Row */}
      <div className="col-xl-12">
        <TablesWidgetDatasets className="card-stretch mb-5 mb-xxl-8" />
      </div>
    </>
  );
};
